/**
 * English dictionary
 * All UI texts are centralized here; template uses $t('key'), logic layer uses this.$t('key')
 */
export default {
  nav: {
    title: 'Tek Smart KB Assistant',
    newSession: 'New Chat',
    locale: 'Language',
    more: 'More',
    zh: '中文',
    en: 'English',
    cancel: 'Cancel',
    theme: 'Theme',
    lightMode: 'Light',
    darkMode: 'Dark',
    model: 'AI Model',
  },
  welcome: {
    title: 'Hi, I\'m XiaoTai',
    desc: 'Ask XiaoTai to summarize answers from the Tek knowledge base',
  },
  input: {
    placeholder: 'Ask a question from the Tek knowledge base',
  },
  disclaimer: 'Answers are AI-generated and for reference only',
  faq: {
    title: 'FAQ',
    desc: 'Tap a question below to get a quick answer',
  },
  source: {
    title: 'Reference sources',
    preview: 'Click to preview the file',
    copyLink: 'Copy download link',
  },
  linkAction: {
    title: 'Document Link',
    preview: 'Preview',
    copyLink: 'Copy download link',
    open: 'Open Source',
  },
  viewer: {
    videoLoadFailed: 'Failed to load video',
    videoErrorDesc: 'The link may be restricted or the signature may have expired. Copy it and open in your browser.',
    copyVideoLink: 'Copy video link',
    download: 'Download file',
    notSupported: 'This file type is not supported for online preview',
    filePreview: 'File Preview',
  },
  ref: {
    title: 'Reference Excerpt',
    chunkUnavailable: 'The referenced excerpt is temporarily unavailable. Click the button below to view the source document.',
    notFound: 'No referenced content found.',
    viewDoc: 'View Document',
    openSource: 'Open Source',
  },
  model: {
    selectTitle: 'Select AI Model',
    group: 'AI Model',
    current: '✓ In use',
  },
  toast: {
    answerError: 'Failed to get an answer. Please try again.',
    answerIncomplete: 'The answer was incomplete. Please try again.',
    answerInterrupted: 'The answer was interrupted. Please try again.',
    noAnswer: 'Sorry, no answer was obtained.',
    qaFailed: 'QA failed: ',
    networkError: 'Network error',
    refNotFound: 'No referenced content found',
    noDownloadLink: 'No download link available for this file',
    linkCopied: 'Link copied. It is valid for 1 hour, please download in time.',
    copyFailed: 'Copy failed. Please copy the link manually.',
    searchFailed: 'Search failed: ',
    stopGenerate: 'Stop generating',
  },
  search: {
    found: 'Found {count} related files:',
    notFound: 'No related files found. Please try other keywords.',
    unnamedFile: 'Untitled file',
  },
  theme: {
    toLight: 'Switch to light mode',
    toDark: 'Switch to dark mode',
  },
  fileType: {
    video: 'Video',
    audio: 'Audio',
    image: 'Image',
  },
};
